
import styled from "styled-components";

const Component = styled.div`
    padding: ${props => props.theme.spacing.m}rem 0;
`;

export default Component;